import React, { Component } from 'react';
import { Button } from 'reactstrap';

class HomePage extends Component {

  handleLogout = () => {
    this.props.onLogout()
  }

  render() {
      return (
        <div className="HomePage">
          <h1>Welcome to the Home Page!</h1>
          <Button color="danger" onClick={this.handleLogout}>Log Out</Button>
        </div>
      );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.jsx